// @flow
import i18n from "i18next";
import k from "src/i18n/keys";
import React, { useMemo } from "react";

import { Pending } from "src/styles/box";
import { NotificationNameOrEmail } from "src/components/messages/Chat/styles";
import { uidToColor } from "src/utils";

import type { UnifizeUser } from "src/types";

import { NameOrEmail as StyledNameOrEmail } from "./styles";

type Props = {
  showPending?: boolean,
  user: UnifizeUser,
  noTooltip?: boolean,
  isCurrentUser?: boolean,
  notificationVariant?: "key" | "value" | "common" | boolean,
};

const NameOrEmail = ({
  user,
  showPending = true,
  noTooltip = false,
  isCurrentUser = false,
  notificationVariant = false,
}: Props) => {
  const color = useMemo(() => uidToColor(user.uid || ""), [user.uid]);

  const renderContent = () => (
    <>
      {user.loading
        ? i18n.t(k.LOADING_USER)
        : isCurrentUser
          ? i18n.t(k.ME_ALWAYS_SELECTS_THE_VIEWER)
          : user.displayName || user.email}
      {user.invitePending &&
      !user.disabled &&
      user.orgRole !== "contact" &&
      showPending ? (
        <Pending> {i18n.t(k.PENDING)} </Pending>
      ) : null}
    </>
  );

  if (noTooltip)
    return <StyledNameOrEmail>{renderContent()}</StyledNameOrEmail>;

  if (notificationVariant)
    return (
      <NotificationNameOrEmail
        color={color}
        data-cy="name-or-email-notification"
        noBold={notificationVariant === "value"}
      >
        {renderContent()}
      </NotificationNameOrEmail>
    );

  return (
    <StyledNameOrEmail
      title={user.displayName || user.email}
      data-cy="name-or-email"
    >
      {renderContent()}
    </StyledNameOrEmail>
  );
};

export default NameOrEmail;
